export default "__VITE_ASSET__BUZxEbpi__"